export default __webpack_public_path__ + "static/media/icon1.ea51ee59.svg";